import React, { useRef } from 'react';
var VeltCommentSidebarV2FilterDropdownTrigger = function (props) {
    var isActive = props.isActive, defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-sidebar-filter-dropdown-trigger-v2", { ref: ref, "is-active": [true, false].includes(isActive) ? (isActive ? 'true' : 'false') : undefined, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentSidebarV2FilterDropdownTrigger;
